import { render, staticRenderFns } from "./Cargos-list.vue?vue&type=template&id=79bb68b5&scoped=true&lang=pug"
import script from "./Cargos-list.vue?vue&type=script&lang=js"
export * from "./Cargos-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb68b5",
  null
  
)

export default component.exports